/**
 * Attach CMS frontend build version for API request logging/monitoring.
 * Backend must allow this header in CORS Access-Control-Allow-Headers.
 */
export function applyCmsBuildHeader (headers) {
  const version = (process.env.VUE_APP_VERSION || '').trim()
  if (!version) return headers

  const next = headers || {}
  next['X-CMS-Build'] = version
  return next
}
